var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoCoin20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_7644_102526)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.34066H10.1743V11.6484H13.278C12.8631 12.7527 11.8506 13.4286 10.3071 13.4286C8.04979 13.4286 6.6556 11.9945 6.6556 10.033C6.6556 8.00549 8.11618 6.57143 10.0747 6.57143C11.3859 6.57143 12.4315 7.16484 12.9129 7.92308L15.1701 6.63736C14.1909 5.08791 12.3154 4 10.0913 4C6.6722 4 4 6.67033 4 10.0165C4 13.3297 6.62241 16 10.2739 16C13.527 16 16 13.8571 16 10.3297V9.34066Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7644_102526",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E9EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoCoin20);
export default __webpack_public_path__ + "static/media/goCoin20.a6f669e20979d05e6af201b698c56466.svg";
export { ForwardRef as ReactComponent };